"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HD_WALLET_SUPPORTED_BLOCKCHAINS = exports.VM_BLOCKCHAIN = exports.TVM_BLOCKCHAIN = exports.EVM_BLOCKCHAIN = exports.BLOCKCHAINS = exports.Blockchain = void 0;
exports.Blockchain = {
    BITCOIN: 'BITCOIN',
    ETHEREUM: 'ETHEREUM',
    BINANCE_SMART_CHAIN: 'BINANCE_SMART_CHAIN',
    TRON: 'TRON',
    POLYGON: 'POLYGON'
};
exports.BLOCKCHAINS = Object.values(exports.Blockchain);
// Blockchains with evm machine
exports.EVM_BLOCKCHAIN = [
    exports.Blockchain.BINANCE_SMART_CHAIN,
    exports.Blockchain.ETHEREUM,
    exports.Blockchain.POLYGON
];
exports.TVM_BLOCKCHAIN = [exports.Blockchain.TRON];
exports.VM_BLOCKCHAIN = [...exports.EVM_BLOCKCHAIN, ...exports.TVM_BLOCKCHAIN];
exports.HD_WALLET_SUPPORTED_BLOCKCHAINS = [
    exports.Blockchain.ETHEREUM,
    exports.Blockchain.BITCOIN,
    exports.Blockchain.TRON
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2tjaGFpbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9CbG9ja2NoYWluLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdhLFFBQUEsVUFBVSxHQUFHO0lBQ3hCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLG1CQUFtQixFQUFFLHFCQUFxQjtJQUMxQyxJQUFJLEVBQUUsTUFBTTtJQUNaLE9BQU8sRUFBRSxTQUFTO0NBQ1YsQ0FBQTtBQUdHLFFBQUEsV0FBVyxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsa0JBQVUsQ0FBQyxDQUFBO0FBRXBELCtCQUErQjtBQUNsQixRQUFBLGNBQWMsR0FBRztJQUM1QixrQkFBVSxDQUFDLG1CQUFtQjtJQUM5QixrQkFBVSxDQUFDLFFBQVE7SUFDbkIsa0JBQVUsQ0FBQyxPQUFPO0NBQ25CLENBQUE7QUFDWSxRQUFBLGNBQWMsR0FBRyxDQUFDLGtCQUFVLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDbEMsUUFBQSxhQUFhLEdBQUcsQ0FBQyxHQUFHLHNCQUFjLEVBQUUsR0FBRyxzQkFBYyxDQUFDLENBQUE7QUFNdEQsUUFBQSwrQkFBK0IsR0FBaUI7SUFDM0Qsa0JBQVUsQ0FBQyxRQUFRO0lBQ25CLGtCQUFVLENBQUMsT0FBTztJQUNsQixrQkFBVSxDQUFDLElBQUk7Q0FDaEIsQ0FBQSJ9